import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_dialog = _resolveComponent("cus-dialog")

  return (_openBlock(), _createBlock(_component_cus_dialog, {
    title: _ctx.title,
    operation: _ctx.operation,
    modelValue: _ctx.dialogFormVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogFormVisible = $event)),
    onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearForm())),
    onOperate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleCreateOrUpdate())),
    processing: _ctx.loading,
    width: "700px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: _ctx.form,
        rules: _ctx.rules,
        ref: "formRef",
        size: "small",
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "申請分類コード",
            prop: "shinseiBunruiCd"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.shinseiBunruiCd,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.shinseiBunruiCd = $event)),
                maxlength: "2",
                disabled: _ctx.operation === _ctx.DialogGenre.Edit
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "申請分類名",
            prop: "shinseiBunruiNm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.shinseiBunruiNm,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.shinseiBunruiNm = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "operation", "modelValue", "processing"]))
}